<template>
  <div
    class="group-row"
    v-if="trade.visibility === 'group' && $featureFlags.groups"
  >
    <router-link class="black--text" :to="groupLink">
      <avatar-or-initials
        size="75"
        :name="trade.posted_by_group.name"
        :image="trade.posted_by_group.picture"
      ></avatar-or-initials>
    </router-link>

    <div class="d-flex flex-column group-row__details">
      <div class="group-row__name">
        <router-link :to="groupLink" class="text-decoration-none black--text">{{
          trade.posted_by_group.name
        }}</router-link>
      </div>
      <div>{{ trade.posted_by_group.participants_count }} Members</div>
      <div class="text--disabled">
        Posted by
        <router-link
          :to="`/profile/${trade.posted_by_id}/${trade.posted_by_name}`"
          class="black--text text-decoration-none"
          >{{ trade.posted_by_name }}</router-link
        >
        •
        <span class="d-inline-block">{{
          trade.created | formatTimestamp
        }}</span>
      </div>
    </div>
    <div class="group-row__badge">
      <div class="d-flex justify-center">
        <img
          src="@/assets/crown.svg"
          alt=""
          width="30px"
          height="30px"
          class=""
          v-if="trade.posted_by_group.group_type === 'Premium'"
        />
        <img
          src="@/assets/private.png"
          alt=""
          width="20px"
          height="20px"
          class="pb-1"
          v-else-if="trade.posted_by_group.group_type === 'Private'"
        />
      </div>
      <v-chip class="group-row__badge__chip pl-5 pr-3" dark color="#2D8CFF"
        >Group</v-chip
      >
    </div>
  </div>
</template>

<script>
import AvatarOrInitials from "../AvatarOrInitials.vue";
export default {
  components: { AvatarOrInitials },
  props: {
    trade: {
      type: Object,
      required: true,
    },
  },

  computed: {
    groupLink() {
      return `/groups/${this.trade.posted_by_group.id}`;
    },
  },
};
</script>

<style scoped>
.group-row {
  display: flex;
  align-items: center;
  padding: 1rem;
  background: #f2f8ff;
  position: relative;
}

.group-row__details {
  font-weight: 400;
  font-size: 0.75rem;
  margin-left: 1rem;
}

.group-row__name {
  font-weight: 900;
  font-size: 1rem;
}

.group-row__badge {
  position: absolute;
  top: 1rem;
  right: 0;
}

.group-row__badge__chip {
  border-radius: 0;
  clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 100%, 15% 50%);
}
</style>
